import hall_bg from'../images/hall_bg.png'
import classroomTables_bg from'../images/classroomTables_bg.png'
import scene_greeting from'../images/scene_greeting.png'
import classroomMain_bg from'../images/classroomMain_bg.png'
import classroomMainCut_bg from'../images/classroomMainCut_bg.png'
import classroomMainCut_bg_presentation0 from'../images/classroomMainCut_bg_presentation0.png'
import classroomMainCut_bg_presentation1 from'../images/classroomMainCut_bg_presentation1.png'
import classroomMainCut_bg_presentation2 from'../images/classroomMainCut_bg_presentation2.png'
import wrongSlide_bg from'../images/wrongSlide_bg.gif'
import characters from'./characters';
import achievements from'./achievements';

const chapter1 = [
  {novel:true, background:hall_bg, startCoordinates:0,
  script:[
  {char:characters["empty"],  position:"center", coordinates: 1, speed:0.5,
  phrases:[
    {text:"It’s been around two weeks since I started this college"},
    {text:"So far nothing special, just a routine."},
    {text:"I’ve already made some friends"},
    {text:"Though I’ve never really been social…"},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 100, speed:0.6,
  phrases:[
    {text:"Оh! Here’s one of them"},
    {text:"It’s Willie, turns out we have a lot in common."},
    {text:"Like me, he’s mostly into politics, gaming and sex lol"},
    {text:"Well… maybe I could say he’s a bit of a perv haha"},
    {text:"Actually, he was the one to make me sign up for this “sex education” minor."},
    {text:"He seems to really expect a lot from it."},
    {text:"And also Phoebe should be somewhere around here..."},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 60, speed:0.5,
  phrases:[
    {text:"Hm.. Strange"},
    {text:"I bet I saw her a minute ago..."},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:0.5,
  phrases:[
    {text:"Hey, Dick!", emotion:characters["willie"].neutral},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 55, speed:0.5,
  phrases:[
    {text:"Wtf"},
    {text:"How did he got here..."},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:0.5,
  phrases:[
    {text:"Ooh I can’t wait for the class to start, dude!", emotion:characters["willie"].neutral},
    {text:"Heard they started this course as an experiment!", emotion:characters["willie"].watchingPhone},
    {text:"I guess the teacher must also be open to some experimenting…", emotion:characters["willie"].snide},
    {text:"If you know what I mean haha", emotion:characters["willie"].snide},
    {text:"I bet it’s some experienced busty milf or a round ass chick who just graduated...", emotion:characters["willie"].snide},
    {text:"...", emotion:characters["willie"].surprised},
    {text:"Don’t tell me it’s her. Jesus.", emotion:characters["willie"].disgust},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:0.7,
  phrases:[
    {text:"Are you guys waiting for… the sex- the sex intercourse, I mean the sex course?", emotion:characters["oldLady"].neutral},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Yeah…", emotion:characters["willie"].disgust},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:0.7,
  phrases:[
    {text:"All right.", emotion:characters["oldLady"].neutral},
    {text:"Your teacher said that she’ll be here soon, so you can come in.", emotion:characters["oldLady"].neutral},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Okay, thank you ma’am.", emotion:characters["willie"].neutral},
  ]
  },
  {char:characters["oldLady"],  position:"right", coordinates: 65, speed:0.7,
  phrases:[
    {text:"In my time young people could figure out how to make children on their own... what a generation…", emotion:characters["oldLady"].frustration},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Jesus thank God it’s not her!", emotion:characters["willie"].neutral},
    {text:"Like one Grandma at home is not enough for me..", emotion:characters["willie"].watchingPhone},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Wait didn’t you see the teacher on the course invitation?", emotion:characters["dick"].neutral_right},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"Well... I was trying to read, not look.", emotion:characters["willie"].watchingPhone},
    {text:"And I went straight to writing the letter, so...", emotion:characters["willie"].neutral},
    {text:"So, will you tell the others to come in?", emotion:characters["willie"].neutral},
    {text:"You know I’m not good with people…", emotion:characters["willie"].watchingPhone, answers:["Shout to classmates to come in.", "Yeah, I’m kind of like that, too."]},
  ]
  },

  //Shout to classmates to come in.
  {option:"Shout to classmates to come in.", start:true},
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Okay, I guess I can try...", emotion:characters["dick"].neutral_right},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 65, speed:1,
  phrases:[
    {text:"*I work up the courage to yell*"},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Ahem", emotion:characters["dick"].neutral_right},
    {text:"Um, GUYS, WE CAN COME IN!", emotion:characters["dick"].rightYelling, achievement:achievements[0]},
    {text:"...", emotion:characters["dick"].rightTired},
  ]
  },
  {char:characters["empty"],  position:"center", coordinates: 65, speed:1,
  phrases:[
    {text:"*Silence*"},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 55, speed:1,
  phrases:[
    {text:"That’s what I was afraid of.", emotion:characters["willie"].watchingPhone},
  ]
  },
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Okay, I don’t think I can do it the second time.", emotion:characters["dick"].rightTired},
    {text:"Let’s just try to walk in, I’m sure they’ll notice and follow us.", emotion:characters["dick"].rightTired},
  ]
  },
  {option:"Shout to classmates to come in.", endOfOption:true},

  //Yeah, I’m kind of like that, too.
  {option:"Yeah, I’m kind of like that, too.", start:true},
  {char:characters["dick"],  position:"right", coordinates: 65, speed:1,
  phrases:[
    {text:"Yeah, so am I dude", emotion:characters["dick"].rightTired},
    {text:"Let’s just try to walk in, I’m sure they’ll notice and follow us.", emotion:characters["dick"].rightTired},
  ]
  },
  {option:"Yeah, I’m kind of like that, too.", endOfOption:true,  endOfOptions:true},
  {endOfNovel:true}
]
},

{novel:true, background:classroomTables_bg, startCoordinates:100,
script:[
{char:characters["empty"],  position:"center", coordinates: 60, speed:0.3,
phrases:[
  {text:"Wow..."},
  {text:"Is it even a classroom or some kind of sex dungeon..."},
  {text:"Suddenly, I saw someone waving at me"},
]
},
{scene:true, img:scene_greeting, start:true, time:300},
{scene:true, name:characters["phoebe"].name, position:"left",
phrases:[
  {text:"Hey guys, I saved us a seat!!!"}
]},
{scene:true, name:characters["empty"].name, position:"center",
phrases:[
  {text:"Phoebe’s kinda quirky and a little… out of this world"},
  {text:"It seems like everything she does is for fun"},
]},
{scene:true, endOfScene:true, time:300, endOfSceneLoadNext:true},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Finally, you’re here!", emotion:characters["phoebe"].laughing},
]
},
{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Wow there’s so much… stuff here lol", emotion:characters["willie"].sittingNeutral},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Yeah", emotion:characters["phoebe"].laughing},
  {text:"A little overwhelming", emotion:characters["phoebe"].smiling},
]
},

{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Oh, I just noticed", emotion:characters["willie"].sittingSurprised},
  {text:"Is that real?", emotion:characters["willie"].sittingQuestion},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"Hmm?", emotion:characters["phoebe"].smiling},
]
},
{char:characters["willie"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Your face...", emotion:characters["willie"].sittingQuestion},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
phrases:[
  {text:"No, it’s henna", emotion:characters["phoebe"].smiling},
  {text:"I decided to get it to protect me from bad luck", emotion:characters["phoebe"].laughing},
  {text:"My horoscope says it’s gonna be a bad day, but it’s up to me", emotion:characters["phoebe"].neutral},
  {text:"So at least I’ve done my part!", emotion:characters["phoebe"].laughing},
]
},
{char:characters["dick"],  position:"right", coordinates: 20, speed:1,
phrases:[
  {text:"Horoscope...", emotion:characters["dick"].sittingNeutral, answers:["Do you really believe in it?", "What does mine say?"]},
]
},

//Do you really believe in it?
  {option:"Do you really believe in it?", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Well, they haven’t let me down yet!", emotion:characters["phoebe"].laughing, achievement:achievements[1]},

  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"For me my grandmother is the best horoscope. I can always tell what my day is gonna be just by looking at her face...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },
  {option:"Do you really believe in it?", endOfOption:true},

  //What does mine say?
  {option:"What does mine say?", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Hmm, you’re a Libra, aren’t you?", emotion:characters["phoebe"].smiling},
    {text:"As far as I remember you’re gonna have a good day today!", emotion:characters["phoebe"].smiling},
    {text:"It says: it’s a good day to work with your hands, all endeavors will finish well!", emotion:characters["phoebe"].laughing},
    {text:"Were you gonna do anything with your hands today?", emotion:characters["phoebe"].smiling},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"I guess I know what you were gonna do hehe", emotion:characters["willie"].sittingSnide},
    {text:"I don’t know guys, to me my grandmother is the best horoscope. I can always tell what my day is gonna be just by looking at her face...", emotion:characters["willie"].sittingLookingToTheSide},
  ]
  },

  {option:"What does mine say?", endOfOption:true, endOfOptions:true},
  //


  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Ahah", emotion:characters["phoebe"].laughing},
    {text:"...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:2,
  phrases:[
    {text:"Oh hi, didn’t expect you to be here, my lovely sister.", emotion:characters["ursula"].standingNeutral},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Same here, didn’t expect such a dumbass to stay at uni for so long...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"WHAT DID YOU JUST CALL ME?", emotion:characters["ursula"].standingAngry},
    {text:"I’LL... I’LL...", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Okay bye...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"I’m not finished with you!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Hey, cool it...", emotion:characters["phoebe"].sittingDisgusted},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"YOU COOL IT!", emotion:characters["ursula"].standingAngry2},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"WHAT THE FUCK??", emotion:characters["phoebe"].sittingCoffeeShocked},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"What? you’ve been begging for it, haven’t you?", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["stacy"],  position:"right", coordinates: 10, speed:1, destinationPoint:[-25, -5, 0, -5],
  phrases:[
    {text:"Let’s go, Ursula, she’s not worth it!", emotion:characters["stacy"].sittingNeutral},
  ]
  },
  {char:characters["ursula"],  position:"left", coordinates: 0, speed:1,
  phrases:[
    {text:"I’LL KICK YOUR STUPID ASS NEXT TIME!", emotion:characters["ursula"].standingAngry},
  ]
  },
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"What a bitch...", emotion:characters["phoebe"].sittingAngry},
    {text:"Now I’m all wet...", emotion:characters["phoebe"].sittingAngry},
    {text:"Well, she had a latte, an iced one", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"How bad is it?", emotion:characters["phoebe"].sittingQuestionCoffee, answers:["Well, I’d say it adds something to your look","Not bad.. But I’d say sheer"]},
  ]
  },

  //Well, I’d say it adds something to your look
  {option:"Well, I’d say it adds something to your look", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Haha, thanks, I think so too!", emotion:characters["phoebe"].sittingLaughingCoffee},
    {text:"And I smell like coffee now, so that’s a plus!", emotion:characters["phoebe"].sittingSmilingCoffee},
  ]
  },
  {option:"Well, I’d say it adds something to your look", endOfOption:true},
  //

  //Not bad.. But I’d say sheer
  {option:"Not bad.. But I’d say sheer", start:true},
  {char:characters["phoebe"],  position:"right", coordinates: 10, speed:1,
  phrases:[
    {text:"Oh, well, it’s okay, I guess!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Yeah it’s totally perfect - I mean, fine...", emotion:characters["willie"].sittingSnide},
  ]
  },
  {option:"Not bad.. But I’d say sheer", endOfOption:true, endOfOptions:true},
  //
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"I didn’t even know you had a twin sister!", emotion:characters["willie"].sittingSurprised},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Honestly, I wish I didn’t", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"So you see, it’s not a good day!", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"God, I can’t stand her. She’s always been like this.", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Always just… messing up my life", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Like - last time when I had someone over, and she...", emotion:characters["phoebe"].sittingDisgustedCoffee},
    {text:"Ah, nevermind, forget it, let’s just change the topic!", emotion:characters["phoebe"].sittingNeutralCoffee},
    {text:"I’m so excited! ", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["willie"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Me too! I think I’m even sweating a little bit...", emotion:characters["willie"].sittingSweating, answers:["I can’t wait for it to start!","I’m still not sure it’s gonna be any fun..."]},
  ]
  },

  //I can’t wait for it to start!
  {option:"I can’t wait for it to start!", start:true},
  {char:characters["profryderhidden"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"I can’t either!", emotion:characters["profryderhidden"].standingHidden},
  ]
  },
  {option:"I can’t wait for it to start!", endOfOption:true},

  //I’m still not sure it’s gonna be any fun...
  {option:"I’m still not sure it’s gonna be any fun...", start:true},
  {char:characters["phoebe"],  position:"left", coordinates: 10, speed:1,
  phrases:[
    {text:"Oh come on, pussy is always fun!", emotion:characters["phoebe"].sittingLaughingCoffee},
  ]
  },
  {char:characters["profryderhidden"],  position:"right", coordinates: 20, speed:1,
  phrases:[
    {text:"Couldn’t agree more!", emotion:characters["profryderhidden"].standingHidden},
  ]
  },
  {option:"I’m still not sure it’s gonna be any fun...", endOfOption:true, endOfOptions:true},
  //
  {endOfNovel:true}
]
},




{novel:true, background:classroomMain_bg, startCoordinates:0,
script:[
{char:characters["profryder"],  position:"right", coordinates: 30, speed:0.4,
phrases:[
  {text:"All right then, let’s get started!", emotion:characters["profryder"].standingSmiling},
  {text:"My name is Ms. Ryder, I’ll be your teacher", emotion:characters["profryder"].standingSmiling},
]
},
{char:characters["willie"],  position:"left", coordinates: 20, speed:1,
phrases:[
  {text:"<small><i>I told ya...</small></i>", emotion:characters["willie"].sittingSnide},
  {text:"<small><i>She looks like she’s from Hogwards with this “wand”</small></i>", emotion:characters["willie"].sittingNeutral},
  {text:"<small><i>Oh I wish she’d cast some erecto patronum on me hehe</small></i>", emotion:characters["willie"].sittingSnide},
]
},
{char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
phrases:[
  {text:"You can treat me as your friend", emotion:characters["profryder"].standingSmiling},
  {text:"Though please don’t forget that I’m still a professor!", emotion:characters["profryder"].standingSmiling},
  {text:"So you probably want to know more about me", emotion:characters["profryder"].standingSmiling},
  {text:"I’m a recent psychology graduate and my major was sex psychology", emotion:characters["profryder"].standingSmiling},
  {text:"Now I’m planning on getting my PhD!", emotion:characters["profryder"].standingSmiling},
  {text:"And no, not the PhD you’re thinking of, but Doctor of Philosophy!", emotion:characters["profryder"].standingLaughing},
  {text:"I’m working on my dissertation right now and I think our classes will help me get some data and a proper lecturer experience.", emotion:characters["profryder"].standingNeutral},
  {text:"However, mainly the course is designed to help you overcome your difficulties with sex and eventually become a real sex guru!", emotion:characters["profryder"].standingLaughing},
  {text:"And, last but not least, I just really wouldn’t want you to be alone with your problems", emotion:characters["profryder"].standingNeutral},
  {text:"So feel free to ask questions, I’ll do my best to satisfy your needs!", emotion:characters["profryder"].standingSmiling},
]
},

{char:characters["howard"],  position:"left", coordinates: 20, speed:1,
phrases:[
  {text:"GIVE US THE SEX!!!", emotion:characters["howard"].sittingNeutral},
]
},

{char:characters["profryder"],  position:"right", coordinates: 30, speed:1,
phrases:[
  {text:"Haha, all in good time, mister!", emotion:characters["profryder"].standingLaughing},
  {text:"Also, I’d really like the atmosphere in the classroom to be friendly and welcoming for sharing and discussion", emotion:characters["profryder"].standingSmiling},
  {text:"So let’s try not to judge each other", emotion:characters["profryder"].standingSmiling},
  {text:"And we’re gonna start with anatomy!", emotion:characters["profryder"].standingSmiling},
  {text:"I think of it as a foundation", emotion:characters["profryder"].standingSmiling},
  {text:"Once we learn it, it’s easier to dive into more complex things and not hurt ourselves and our partner!", emotion:characters["profryder"].standingLaughing},
  {text:"The topic is quite extensive, but I’m giving you my own crash course with the most important parts", emotion:characters["profryder"].standingSmiling},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:0.4, noBlur:true, destinationPoint:[-25,-15, -10,-15], appearAfterMoving:true,
phrases:[
  {text:"Okay. Who can tell me what this is?", emotion:characters["profryder"].standingLaughing},
]
},
{char:characters["howard"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"VAGINA!", emotion:characters["howard"].sittingNeutral},
]
},
{char:characters["phoebe"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"Ahah", emotion:characters["phoebe"].sittingLaughingCoffee},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Any other options?", emotion:characters["profryder"].standingLaughing},
]
},
{char:characters["willie"],  position:"left", coordinates: 0, speed:1, destinationPoint:[-15,-10, 0, -10],
phrases:[
  {text:"<small><i>Pussy</small></i>", emotion:characters["willie"].sittingSnide},
]
},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Well, basically, yeah, it’s a pussy", emotion:characters["profryder"].standingLaughing},
  {text:"But I’d like to hear the anatomical name", emotion:characters["profryder"].standingEyebrowsUp, answers:["Clitoris","Vulva","Labia"]},
]
},

//Clitoris
{option:"Clitoris", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Well, it’s definitely there, but it’s only part of what’s called the vulva", emotion:characters["profryder"].standingSmiling},
]
},
{option:"Clitoris", endOfOption:true},
//Vulva
{option:"Vulva", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Great, that’s right! ", emotion:characters["profryder"].standingLaughing, achievement:achievements[2]},
]
},
{option:"Vulva", endOfOption:true},
//Labia
{option:"Labia", start:true},
{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"Well, they take up a lot of space, but they’re just part of what’s called the vulva!", emotion:characters["profryder"].standingSmiling},
]
},
{option:"Labia", endOfOption:true, endOfOptions:true},
//

{char:characters["profryder"],  position:"right", coordinates: 7, speed:1, noBlur:true, destinationPoint:[-25,-15, -10,-15],
phrases:[
  {text:"So basically, the vulva is the outer part of the female genitalia", emotion:characters["profryder"].standingSmiling},
  {text:"Now, let’s take a deeper look at what it’s made up of!", emotion:characters["profryder"].standingSmiling},
  {text:"And I’d listen carefully, ‘cause today we’re going to have a little quiz", emotion:characters["profryder"].standingSmiling},
  {text:"Plus at the end of the lesson you will also have a practical part, where this is going to be quite handy!", emotion:characters["profryder"].standingSmiling},
]
},
{endOfNovel:true},
]
},

{novel:true, background:classroomMainCut_bg_presentation0, startCoordinates:0,
script:[
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:0.5, noBlur:true, destinationPoint:[-25,-15, -15, -15], appearAfterMoving:true,
  phrases:[
    {text:"Welcome to the delicious world of vulva!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation1},
  {char:characters["profryder"],  position:"right", startCoordinates:0, coordinates: 100, speed:0.5, noBlur:true, destinationPoint:[-25,-15,-15,-15], appearAfterMoving:true,
  phrases:[
    {text:"What we usually see on the surface is called the labia majora", emotion:characters["profryder"].standingSmiling},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"I’d kiss them all over haha!", emotion:characters["howard"].sittingSnide},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"...", emotion:characters["profryder"].standingSurprised},
    {text:"They’re made up of regular skin and can be the same color or a little darker", emotion:characters["profryder"].standingNeutral},
    {text:"And right there they are followed by the labia minora", emotion:characters["profryder"].standingNeutral},
    {text:"They are usually pink or dark brown, depending on the color of your skin...", emotion:characters["profryder"].standingBlushed},
    {text:"Together with the outer labia, they have a protective function", emotion:characters["profryder"].standingNeutral},
    {text:"And what exactly do they protect?", emotion:characters["profryder"].standingEyebrowsUp},
  ]
  },
  {changeBG:true, img:classroomMainCut_bg_presentation2},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"This area, called the vaginal vestibule", emotion:characters["profryder"].standingNeutral},
    {text:"It includes:", emotion:characters["profryder"].standingNeutral},
    {text:"Glands, like the lesser vestibular glands, which by the way work similarly to the male prostate", emotion:characters["profryder"].standingSmiling},
    {text:"They are claimed to be the source of female ejaculation, I mean squirt, but this has not been proven so far", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Wow, I’m really learning something new!</small></i>", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Well, nevertheless, more experiments are left to us! we’ll definitely have a lesson about this!", emotion:characters["profryder"].standingLaughing},
  ]
  },

  //
  {changeBG:true, img:wrongSlide_bg},
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"Whoops", emotion:characters["profryder"].standingBlushed},
  ]
  },
  {char:characters["howard"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"Oh yeah baby just like that!", emotion:characters["howard"].sittingSnide},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"I apologize, this should’ve been in the... the practical part", emotion:characters["profryder"].standingBlushed},
    {text:"I guess I… shouldn’t have been doing the presentation at 2 am!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {char:characters["willie"],  position:"left", coordinates: 80, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>I wonder if she made this guide herself...</small></i>", emotion:characters["willie"].sittingSnide},
  ]
  },
  {char:characters["phoebe"],  position:"left", coordinates: 75, speed:1, destinationPoint:[-15,-10, 0, -10],
  phrases:[
    {text:"<small><i>Haha, I bet</small></i>", emotion:characters["phoebe"].sittingSurprisedCoffee},
  ]
  },
  {char:characters["profryder"],  position:"right", coordinates: 100, speed:1, noBlur:true, destinationPoint:[-25,-15,-15,-15],
  phrases:[
    {text:"So, umm.. Let’s return to our muttons!", emotion:characters["profryder"].standingLaughing},
  ]
  },
  {endOfNovel:true, endOfGame:true}
]
},

{blackScreen:true, txt:["<h2>Thank you for playing! I hope you enjoyed the demo!</h2>","<h2>Right now I’m working on a practice part, which is going to be a mini game where !spoiler! you are going to help your classmate masturbate under the guidance of your professor!</h2>","<h2>If you liked the demo, please support me on patreon, it really helps me keep doing this thing and release new chapters more often!</h2> <br/> Also feel free to give any feedback down below, I would really appreciate it!"], end:true},


  /*
  {novel:true, background:hall_bg,
  script:[
  {char:characters["phoebe"],  position:"left", startCoordinates:-50, coordinates: 0, speed:0.5,
  phrases:[
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
    {item:sheet, open:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
    {item:sheet, close:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral, achievement:achievements[2]},
  ]
  },
 {
  char:characters["phoebe2"],  position:"left", coordinates: 1, speed:1,
  phrases:[
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
    {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
  ]
  },
  {scene:true, img:hall_bg, start:true},
  {scene:true, name:characters["phoebe2"].name, position:"right",
  phrases:[
    {text:"Lorem ipsum dolor sit amet"},
  ]},
  {scene:true, name:characters["phoebe2"].name, position:"right",
  phrases:[
    {text:"Lorem ipsum dolor sit amet"},
      {text:"??", answers:["yay", "nay", "lol"]}
  ]},
  {option:"yay", start:true},
  {scene:true, name:characters["phoebe2"].name, position:"right",
  phrases:[
    {text:"??"}
  ]},
  {option:"yay", endOfOption:true},
  {option:"nay", start:true},

  {option:"nay", endOfOption:true, endOfOptions:true},
  {scene:true, endOfScene:true},

 {char:characters["phoebe"],  position:"left", coordinates: 0, speed:0.7,
 phrases:[
  {text:"Lorem ipsum dolor sit amet22", emotion:characters["phoebe"].laughing},
  {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].neutral},
  {text:"Lorem ipsum dolor sit amet", emotion:characters["phoebe"].laughing, animation:true},
  {text:"??", answers:["yay", "nay", "lol"], emotion:characters["phoebe"].smile}
 ]
 },
 {option:"yay", start:true},

 {char:characters["phoebe"],  position:"left", coordinates: 0, speed:1.2,
 phrases:[
  {text:"u chose yay option", emotion:characters["phoebe"].laughing, animation:true, achievement:achievements[0]},
  {text:"u chose yay option", emotion:characters["phoebe"].smile},
 ]
 },
 {option:"yay", endOfOption:true},

 {option:"nay", start:true},
 {char:characters["phoebe"],  position:"right", coordinates: -50, speed:1,
 phrases:[
  {text:"u chose nay option", emotion:characters["phoebe"].smile}
 ]
 },
 {option:"nay", endOfOption:true},

 {option:"lol", start:true},
 {char:characters["phoebe"],  position:"left", coordinates: -50, speed:1.2,
 phrases:[
  {text:"u chose lol option", emotion:characters["phoebe"].smile}
 ]
 },
 {option:"lol", endOfOption:true, endOfOptions:true},

 {
 char:characters["phoebe"],  position:"left", coordinates: 0, speed:1.2,
 phrases:[
  {text:"endgf", emotion:characters["phoebe"].smile}
 ]
 }
]
},
*/

];

export default chapter1;
